<template>
  <div class="float-right">
    <div class="row all-button-align pr-5">
      <div class="col p-0">
        <uploadDownload />
      </div>
      <div class="col p-0">
        <userInfo />
      </div>
      <div class="position-relative">
        <button
          type="button"
          class="btn versionToggleBtn p-0"
          @click="versionToggle"
        >
          <img
            class="svg-inline--fa fa-w-16"
            :src="Version"
            alt="Version icon"
            :title="'Data version'"
          />
        </button>
        <div v-if="versionToggleValue">
          <div
            class="position-absolute versionToggleValue"
            v-if="options.length"
          >
            <b-form-select
              v-model="selected"
              @change="changeSelectedVersion"
              :options="options"
            ></b-form-select>
            <div class="col-12 py-2 version-btn">
              <button
                type="button"
                class="btn p-0 mx-2 version-apply-btn"
                @click="saveSelectedVersion"
                variant="success"
                :disabled="saveButtonToggleHandler"
              >
                <b-icon
                  icon="check-circle-fill"
                  variant="primary"
                  title="Save"
                ></b-icon>
              </button>
              <button
                type="button"
                class="btn p-0 version-close-btn"
                @click="versionToggle"
                variant="warning"
              >
                <b-icon
                  icon="x-circle-fill"
                  variant="danger"
                  title="Cancel"
                ></b-icon>
              </button>
            </div>
          </div>
          <div
            class="position-absolute versionToggleValue text-left p-1"
            v-else
          >
            No Version
          </div>
        </div>
      </div>
      <div class="col p-0">
        <b-dropdown
          v-if="!isFullScreen"
          v-b-tooltip.hover
          :title="'Download'"
          id="dropdown-1"
          text="Dropdown Button"
          class="exportDropDown text-dark"
          offset="-50"
          no-caret
          variant="link"
        >
          <template v-slot:button-content>
            <i class="fas fa-download"></i>
          </template>
          <b-dropdown-item @click="downloadVisualReport"
            >Export as PNG</b-dropdown-item
          >
          <b-dropdown-item @click="exportToPDF">Export as PDF</b-dropdown-item>
          <!--<b-dropdown-item>Export as PPT</b-dropdown-item>-->
        </b-dropdown>
      </div>
      <div class="col p-0">
        <b-link
          class="text-dark fullscreenBtn"
          @click="toggle"
          v-b-tooltip.hover
          v-bind:title="!isFullScreen ? 'Full Screen' : 'close screen'"
        >
          <i class="fas fa-expand" style="color: #007bff;"></i>
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import { mapActions, mapGetters } from "vuex";
import version from "../assets/img/px-version.svg";
import userInfo from "../components/userInfo/userInfo.vue";
import uploadDownload from "../components/Common/upload-download/upload-download.vue";
export default {
  name: "downloadChart",
  props: {
    downloadData: Object,
    fileName: String,
    commitName: {
      default: "",
      type: String,
    },
  },
  components: {
    userInfo,
    uploadDownload,
  },
  computed: {
    ...mapGetters({
      isFullScreen: "isFullScreen",
      chartDownloadInfo: "chartDownloadInfo",
      historyCalDropDown: "historyCalDropDown",
      currentVersionaHolder: "currentVersionaHolder",
    }),
    saveButtonToggleHandler() {
      if (
        this.historyCalDropDown &&
        this.historyCalDropDown.current_version &&
        this.historyCalDropDown.current_version.table_pk &&
        this.historyCalDropDown.current_version.table_pk == this.selected
      ) {
        return true;
      } else {
        if (!this.historyCalDropDown) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  data() {
    return {
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      selected: null,
      options: [],
      versionToggleValue:
        this.currentVersionaHolder &&
        this.currentVersionaHolder.versionToggleValue
          ? this.currentVersionaHolder.versionToggleValue
          : false,
      Version: version,
      downloadFileName: "",
    };
  },
  mounted() {
    this.versionToggleValue =
      this.currentVersionaHolder &&
      this.currentVersionaHolder.versionToggleValue
        ? this.currentVersionaHolder.versionToggleValue
        : false;
    if (
      this.currentVersionaHolder &&
      this.currentVersionaHolder.version_data &&
      this.currentVersionaHolder.version_data.table_pk &&
      this.versionToggleValue
    ) {
      this.selected = this.currentVersionaHolder.version_data.table_pk;
      this.selectedValueHandler(this.currentVersionaHolder);
    } else {
      this.selected =
        this.historyCalDropDown &&
        this.historyCalDropDown.current_version &&
        this.historyCalDropDown.current_version.table_pk
          ? this.historyCalDropDown.current_version.table_pk
          : null;
      this.selectedValueHandler(this.historyCalDropDown);
      // this.selected = null;
    }
    let payLoadObj = {
      table_pk: this.selected,
      chart_id:
        this.historyCalDropDown &&
        this.historyCalDropDown.current_version &&
        this.historyCalDropDown.current_version.chart_id
          ? this.historyCalDropDown.current_version.chart_id
          : null,
      chartName: this.commitName,
    };
    let version = {
      version_data: payLoadObj,
      versionToggleValue: false,
    };
    this.currentVersionUpdateHandler(version);
    // console.log("Download--mounteddddddd", this.historyCalDropDown);
    // console.log("Download--currentVersionaHolder", !this.currentVersionaHolder, this.currentVersionaHolder);

    if (
      this.versionToggleValue &&
      this.currentVersionaHolder.versionToggleValue
    ) {
      this.selectedValueHandler(this.currentVersionaHolder);
    }
    let fileNameArr = this.$route.path.split("/");
    this.downloadFileName = fileNameArr[fileNameArr.length - 1];
  },
  watch: {
    currentVersionaHolder: {
      deep: true,
      handler() {
        this.selectOptionHandler(this.historyCalDropDown);
        this.selected =
          this.currentVersionaHolder &&
          this.currentVersionaHolder.version_data &&
          this.currentVersionaHolder.version_data.table_pk
            ? this.currentVersionaHolder.version_data.table_pk
            : null;
        // console.log("watcherrrrrrrrrrrrrr", this.selected);
      },
    },
  },
  methods: {
    ...mapActions([
      "setScreenStatus",
      "getChartDataById",
      "getChartHistoricalData",
      "saveChartHistoricalData",
      "currentVersionUpdateHandler",
    ]),
    toggle() {
      this.setScreenStatus(!this.isFullScreen);
    },
    versionToggle() {
      this.versionToggleValue = !this.versionToggleValue;
    },
    changeSelectedVersion() {
      // console.log("Download--Copmonenttttt", this.historyCalDropDown);
      let payLoadObj = {
        table_pk: this.selected,
        chart_id: this.historyCalDropDown.current_version.chart_id,
        chartName: this.commitName,
      };
      let version = {
        version_data: payLoadObj,
        versionToggleValue: this.versionToggleValue,
      };
      this.currentVersionUpdateHandler(version);
      for (let his in this.historyCalDropDown) {
        // console.log("dddddddddddddddddd", his);
        if (
          his === "current_version" &&
          this.historyCalDropDown[his] &&
          this.historyCalDropDown[his] &&
          this.historyCalDropDown[his].table_pk === this.selected
        ) {
          // console.log("hisssssssssss", his);
          payLoadObj.version = "current-version";
        }
      }
      // console.log("this.selected", payLoadObj);
      this.getChartHistoricalData(payLoadObj);
      // this.$emit("currentVersionId", this.selected);
    },
    async saveSelectedVersion() {
      // console.log("this.selected", this.selected);
      let payLoadObj = {
        table_pk: this.selected,
        chart_id: this.historyCalDropDown.current_version.chart_id,
        chartName: this.commitName,
      };
      // console.log("payLoadObj", payLoadObj);
      await this.saveChartHistoricalData(payLoadObj);
      let payLoad = {
        id: payLoadObj.chart_id,
        chartName: this.commitName,
        navigate: false,
      };
      await this.getChartDataById(payLoad);
      let versionObj = {
        table_pk: this.selected,
        chart_id: this.historyCalDropDown.current_version.chart_id,
        chartName: this.commitName,
      };
      let version = {
        version_data: versionObj,
        versionToggleValue: false,
      };
      this.currentVersionUpdateHandler(version);
    },
    downloadVisualReport() {
      // let vc = this.panelRef;
      // alert("Descargando reporte visual")

      // console.log("campaign-view#downloadVisualReport", this.chartDownloadInfo);
      html2canvas(this.chartDownloadInfo.downloadData)
        .then((canvas) => {
          // document.body.appendChild(canvas)
          var a = document.createElement("a");
          // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
          a.href = canvas
            .toDataURL("image/jpeg")
            .replace("image/jpeg", "image/octet-stream");
          a.download = this.downloadFileName + ".jpg";
          a.click();
        })
        .catch((error) => {
          console.log("Erorr descargando reporte visual", error);
        });
    },
    exportToPDF() {
      // console.log("export pdf", this.chartDownloadInfo);
      html2pdf(this.chartDownloadInfo.downloadData, {
        margin: [1, 0, 1, 1],
        filename: this.downloadFileName + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      });
    },
    selectedValueHandler(selectedValObj) {
      if (
        selectedValObj &&
        selectedValObj.version_data &&
        selectedValObj.version_data.table_pk
      ) {
        this.selected = selectedValObj.version_data.table_pk;
      } else {
        if (
          this.historyCalDropDown &&
          this.historyCalDropDown.version_data &&
          this.historyCalDropDown.version_data.table_pk
        ) {
          this.selected = this.historyCalDropDown.version_data.table_pk;
        }
      }
    },
    selectOptionHandler(optionData) {
      let optionsList = [];
      for (let drop in optionData) {
        let value;
        if (drop === "current_version") {
          value = optionData[drop].table_pk;
        } else {
          value = optionData[drop].table_pk;
        }
        let obj = {
          value: value,
          text: drop.replace("_", " "),
        };
        optionsList.push(obj);
      }
      this.options = optionsList;
    },
  },
};
</script>

<style lang="scss">
.slider-track {
  .slider.slider-horizontal .slider-selection,
  .slider.slider-horizontal .slider-track-low,
  .slider.slider-horizontal .slider-track-high,
  .slider-track-low,
  .slider-track-high,
  .slider-selection {
    box-shadow: unset;
    background: #f7f3f3 !important;
    border: 1px solid #dddbdb;
  }
  .slider-selection {
    background: #dddbdb !important;
  }
}
</style>
<style lang="scss" scoped>
.all-button-align {
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
// .versionToggleBtn {
//   width: 117px;
// }
.btn,
.btn:focus,
.btn.focus {
  outline: none;
  border: none !important;
  box-shadow: none !important;
}
.version-btn {
  // .version-apply-btn {
  //   color: blue;
  // }
  // .version-close-btn {
  //   color: red;
  // }
}
i {
  color: #007bff;
}
.versionToggleValue {
  top: 25px;
  right: 0;
  z-index: 100;
  width: 200px !important;
  background: #fff;
  border: 1px solid #ccc;
  select {
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
    border-radius: 0;
    height: 30px;
    padding: 0 10px;
  }
}
.btn.disabled,
.btn:disabled {
  cursor: not-allowed;
}
</style>
